import home from './home/store';

export default {
  namespaced: true,
  modules: { home },
};
